// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#bdpListDetails .get-direct-link {
  position: absolute;
  z-index: 9;
  right: 4%;
  margin-top: 10px;
}
#bdpListDetails .bdp-record-overload {
  background-color: #ffcece;
  color: #1d2125;
  padding: 20px 20px 20px 20px;
  border-radius: 6px;
}
#bdpListDetails #logisticMilestoneColumn .forteen {
  width: 14%;
}
#bdpListDetails #logisticMilestoneColumn .seventeen {
  width: 17%;
}
#bdpListDetails #logisticMilestoneColumn .fifteen {
  width: 15%;
}
#bdpListDetails #logisticMilestoneColumn .ninteen {
  width: 19%;
}
#bdpListDetails #viewDocs {
  margin-right: 12px;
  background: white;
  text-decoration: underline;
}
#bdpListDetails ::ng-deep .p-tabview .p-tabview-nav {
  background: #e2edf6;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}
#bdpListDetails ::ng-deep .p-dropdown .p-dropdown-panel {
  top: -106px !important;
}
#bdpListDetails ::ng-deep .p-tabview .p-tabview-nav::-webkit-scrollbar {
  height: 2px;
}
#bdpListDetails ::ng-deep .p-tabview .p-tabview-nav::-webkit-scrollbar-track {
  border-radius: 10px;
}
#bdpListDetails ::ng-deep .bdp-milestone-switcher {
  display: inline-block;
  margin-top: 10px;
}
#bdpListDetails ::ng-deep .p-toggleswitch.bdp-milestone-switcher {
  --p-toggleswitch-width: 420px;
  --p-toggleswitch-height: 30px;
  --p-toggleswitch-border-radius: 16px;
  --p-toggleswitch-background: #2d74ff;
  --p-toggleswitch-checked-background: #2d74ff;
  --p-toggleswitch-hover-background: #2d74ff;
  --p-toggleswitch-checked-hover-background: #2d74ff;
  --p-toggleswitch-handle-size: 50%;
  --p-toggleswitch-handle-border-radius: 16px;
  --p-toggleswitch-handle-background: #ffffff;
  --p-toggleswitch-handle-checked-background: #ffffff;
  --p-toggleswitch-slide-duration: 0.4s;
}
#bdpListDetails ::ng-deep .p-toggleswitch.bdp-milestone-switcher .p-toggleswitch-slider {
  width: 420px;
  height: 30px;
  background-color: #2d74ff;
  position: relative;
  border-radius: 16px;
  margin-top: 10px;
  margin-bottom: 8px;
}
#bdpListDetails ::ng-deep .p-toggleswitch.bdp-milestone-switcher .p-toggleswitch-slider::before {
  content: "Logistics Milestones";
  height: 26px;
  width: 50%;
  position: absolute;
  left: 3px;
  top: 2px;
  text-align: center;
  border-radius: 16px;
  background-color: #ffffff;
  line-height: 24px;
  font-weight: 600;
  transition: transform 0.4s ease;
}
#bdpListDetails ::ng-deep .p-toggleswitch.bdp-milestone-switcher .p-toggleswitch-slider::after {
  content: "File Milestones";
  height: 26px;
  width: 50%;
  position: absolute;
  right: 3px;
  top: 2px;
  text-align: center;
  color: #ffffff;
  line-height: 24px;
  font-weight: 600;
  transition: transform 0.4s ease;
}
#bdpListDetails ::ng-deep .p-toggleswitch.bdp-milestone-switcher.p-toggleswitch-checked .p-toggleswitch-slider::before {
  transform: translateX(204px);
}
#bdpListDetails ::ng-deep .p-toggleswitch.bdp-milestone-switcher.p-toggleswitch-checked .p-toggleswitch-slider::after {
  transform: translateX(-204px);
}
#bdpListDetails ::ng-deep .p-toggleswitch {
  color: #a9a9a9 !important;
}
#bdpListDetails ::ng-deep .bdp-route-switcher {
  display: inline-block;
  margin-top: 10px;
}
#bdpListDetails ::ng-deep .bdp-app-switcher {
  display: inline-block;
  margin-top: 10px;
}
#bdpListDetails ::ng-deep .bdp-app-switcher.p-inputswitch-checked .p-inputswitch-slider::before {
  transform: translateX(196px);
  left: 10px;
  content: "View Documents";
}
#bdpListDetails ::ng-deep .bdp-app-switcher.p-inputswitch-checked .p-inputswitch-slider::after {
  transform: translateX(0px);
  content: "Document Distribution";
}
#bdpListDetails ::ng-deep .bdp-app-switcher .p-inputswitch-slider {
  background-color: #2D74FF;
  display: block;
  margin-top: 10px;
  margin-bottom: 8px;
  width: 420px;
  height: 30px;
}
#bdpListDetails ::ng-deep .bdp-app-switcher .p-inputswitch-slider::before {
  height: 26px !important;
  width: 50% !important;
  left: 3px;
  top: 11px;
  text-align: center;
  border-radius: 16px;
  content: "Document Distribution";
  line-height: 24px;
  font-weight: 600;
}
#bdpListDetails ::ng-deep .bdp-app-switcher .p-inputswitch-slider::after {
  height: 28px;
  width: 50%;
  color: #fff;
  position: absolute;
  text-align: center;
  content: "View Documents";
  line-height: 28px;
  transform: translateX(196px);
}
#bdpListDetails ::ng-deep .bdp-milestone-switcher {
  pointer-events: none;
  display: inline-block;
  margin-top: 10px;
}
#bdpListDetails ::ng-deep .bdp-milestone-switcher .p-inputswitch {
  cursor: not-allowed;
}
#bdpListDetails ::ng-deep .bdp-milestone-switcher.p-inputswitch-checked .p-inputswitch-slider::before {
  transform: translateX(196px);
  left: 10px;
  height: 26px !important;
  width: 50% !important;
  left: 3px;
  top: 11px;
  text-align: center;
  border-radius: 16px;
  content: "Logistics Milestones";
  line-height: 24px;
  font-weight: 600;
  background-color: #2D74FF;
  color: white;
  position: absolute;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
#bdpListDetails ::ng-deep .bdp-milestone-switcher .p-inputswitch-slider {
  background-color: white;
  display: block;
  margin-top: 10px;
  margin-bottom: 8px;
  width: 420px;
  height: 30px;
}
#bdpListDetails ::ng-deep .bdp-milestone-switcher .p-inputswitch-slider::before {
  height: 26px !important;
  width: 50% !important;
  left: 3px;
  top: 11px;
  text-align: center;
  border-radius: 16px;
  content: "Logistics Milestones";
  line-height: 24px;
  font-weight: 600;
  background-color: #2D74FF !important;
  color: white;
}
#bdpListDetails ::ng-deep .bdp-milestone-switcher-wrapper {
  padding-bottom: 40px;
}
#bdpListDetails ::ng-deep .p-tabview .p-tabview-nav::-webkit-scrollbar-thumb {
  border-radius: 10px;
}
#bdpListDetails ::ng-deep #linkOverlay button.p-button {
  background-color: #ff2ded;
  color: rgb(255, 255, 255);
}
#bdpListDetails ::ng-deep #linkOverlay .p-overlaypanel-content {
  width: 550px;
}
#bdpListDetails ::ng-deep #linkOverlay input {
  width: 405px;
}
#bdpListDetails .legs-background {
  color: #2d74ff !important;
  border-radius: 3px;
}
#bdpListDetails .legs-geoFenceFlag-background {
  border-radius: 3px;
}
#bdpListDetails #docTable ::ng-deep .p-datatable table {
  display: grid;
}
#bdpListDetails ::ng-deep .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  background: #e2edf6;
}
#bdpListDetails ::ng-deep .p-tabview .p-tabview-nav li .p-tabview-nav-link {
  background: #e2edf6;
  padding: 16px 24px !important;
}
#bdpListDetails :ng-deep .p-tabview .p-tabview-nav li .p-tabview-nav-link:focus {
  box-shadow: none;
}
#bdpListDetails :ng-deep .p-tabview .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus {
  box-shadow: none;
}
#bdpListDetails ::ng-deep .p-tabview .p-tabview-panels {
  padding: 2px 8px 0px 16px !important;
}
#bdpListDetails ::ng-deep .p-datatable .p-datatable-thead > tr > th {
  background: white !important;
  border: none !important;
  padding-top: 20px;
}
#bdpListDetails ::ng-deep .p-datatable .p-datatable-tbody > tr > td {
  padding-left: 5;
  border: none;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
#bdpListDetails #docTable ::ng-deep .p-datatable .p-datatable-tbody > tr > td {
  width: 30% !important;
}
#bdpListDetails #legs ::ng-deep .p-datatable .p-datatable-tbody > tr > td {
  padding-left: 5;
  border: none;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
#bdpListDetails ::ng-deep .p-tabview .p-tabview-panels {
  max-height: 602px !important;
  padding: 0 !important;
  overflow: auto !important;
}
#bdpListDetails ::ng-deep .p-datatable .p-datatable-header {
  background: none !important;
  border: none !important;
  padding: 0 !important;
}
#bdpListDetails ::ng-deep .p-tabview-nav-link {
  color: #1d2125;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  height: 56px;
}
#bdpListDetails ::ng-deep .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  color: #2d74ff !important;
}
#bdpListDetails ::ng-deep .p-datatable .p-datatable-scrollable-header {
  background: white !important;
}
#bdpListDetails ::ng-deep .p-badge.bdp-alert-badge {
  position: absolute;
  top: 4px;
  right: 8px;
}
#bdpListDetails ::ng-deep .docsTable {
  overflow-y: hidden !important;
  max-height: 35.6em !important;
}
#bdpListDetails ::ng-deep .docPanel {
  max-height: 600px !important;
  padding: 0 !important;
  overflow-y: hidden !important;
}
#bdpListDetails ::ng-deep .bdp-align-ctrl {
  justify-content: space-between;
  display: flex;
  flex-direction: row;
}
#bdpListDetails ::ng-deep .bdp-align-ctrl .p-dataview-layout-options button {
  height: 32px;
}
#bdpListDetails ::ng-deep .bdp-align-ctrl #badgeButton .p-button {
  padding: 4px;
  background-color: #2f80ed;
  line-height: 1px;
  color: white;
}
#bdpListDetails ::ng-deep .bdp-align-ctrl #badgeButton .p-button .p-badge {
  margin: 0px 10px;
}
#bdpListDetails ::ng-deep .bdp-alert-list {
  position: relative;
}
#bdpListDetails ::ng-deep .bdp-alert-list .bdp-alert-list-item {
  margin: 10px;
}
#bdpListDetails ::ng-deep .bdp-alert-list .readBackground {
  background: #edfaff;
  font-weight: bold;
}
#bdpListDetails ::ng-deep .bdp-alert-list .bdp-alert {
  float: left;
  width: 100%;
  margin: 15px 0px;
  /* border: 1px solid #ccc; */
  border-radius: 6px;
  padding: 10px 20px;
  box-shadow: 0px 1px 5px -1px #444;
  cursor: pointer;
}
#bdpListDetails ::ng-deep .bdp-alert-list .bdp-alert.bdp-vesselDelay {
  border-left: 6px solid #1da9e1;
}
#bdpListDetails ::ng-deep .bdp-alert-list .bdp-alert.bdp-bookings, #bdpListDetails ::ng-deep .bdp-alert-list .bdp-alert.bdp-omission {
  border-left: 6px solid #e3e3e4;
}
#bdpListDetails ::ng-deep .bdp-alert-list .bdp-alert .notif-heading .bdp-heading span {
  min-width: 30px;
  height: 30px;
  float: left;
  text-align: center;
  margin-right: 10px;
  align-items: center;
  display: flex;
}
#bdpListDetails ::ng-deep .bdp-alert-list .bdp-alert .notif-heading .bdp-heading span i.bdp-icon {
  color: #fff;
  width: 100%;
  height: 100%;
  background: #1b74c5;
  border-radius: 15px;
  line-height: 31px;
}
#bdpListDetails ::ng-deep .bdp-alert-list .bdp-alert .notif-heading .bdp-heading.bdp-alert-label {
  font-size: 16px;
}
#bdpListDetails ::ng-deep .bdp-alert-list .bdp-alert .notif-heading .bdp-menu-icon {
  width: 24px;
  text-align: center;
  float: right;
  height: 24px;
  border-radius: 3px;
  padding: 5px;
}
#bdpListDetails ::ng-deep .bdp-alert-list .bdp-alert .notif-heading .bdp-menu-icon:hover {
  background-color: #2d74ff;
  color: #fff;
}
#bdpListDetails ::ng-deep .bdp-alert-list .bdp-alert .notif-heading ::ng-deep .p-overlaypanel {
  margin-top: 10px;
  position: absolute;
  top: 60px !important;
  right: 40px !important;
  left: auto !important;
}
#bdpListDetails ::ng-deep .bdp-alert-list .bdp-alert .notif-heading ::ng-deep .p-overlaypanel:after,
#bdpListDetails ::ng-deep .bdp-alert-list .bdp-alert .notif-heading ::ng-deep .p-overlaypanel:before {
  content: normal;
}
#bdpListDetails ::ng-deep .bdp-alert-list .bdp-alert .notif-heading ::ng-deep p {
  padding: 5px 10px;
  border-radius: 6px;
}
#bdpListDetails ::ng-deep .bdp-alert-list .bdp-alert .notif-heading ::ng-deep p.bdp-disabled {
  pointer-events: none;
  color: #fff;
  background-color: #d6d6d6;
}
#bdpListDetails ::ng-deep .bdp-alert-list .bdp-alert .notif-heading ::ng-deep p:hover {
  background-color: #2f80ed;
  color: #fff;
}
#bdpListDetails #eventName .list-item-text-ellipses {
  max-width: 140px;
}
#bdpListDetails #vessel .list-item-text-ellipses {
  max-width: 110px;
}
#bdpListDetails #eventLocation .list-item-text-ellipses {
  max-width: 120px;
}
#bdpListDetails #hideEventCodeToggle {
  float: right;
  display: flex;
}
#bdpListDetails .shipment-information-header-font {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  color: #1d2125;
  white-space: nowrap;
  background: #ccc;
  float: left;
  padding: 5px 5px;
  border-radius: 3px;
}
#bdpListDetails .box-icon-header {
  text-align: left;
  width: 2rem;
}
#bdpListDetails .box-icon {
  font-size: 16px;
  color: #e8f1f8;
  margin-right: 8px;
}
#bdpListDetails .p-tag {
  border-radius: 10rem !important;
  background: #1d2125;
}
#bdpListDetails .color {
  color: #2d74ff;
}
#bdpListDetails .check-icon {
  font-size: 12px;
}
#bdpListDetails .list-details-header {
  font-size: 20px;
  color: #1d2125 !important;
  line-height: 24px;
}
#bdpListDetails .back-button {
  background: #e8f1f8;
  border: none;
  outline: none;
  color: #323232;
}
#bdpListDetails .angle-left-right {
  background: #e8f1f8;
  border: none;
  outline: none;
  font-size: 16px;
  color: #323232;
}
#bdpListDetails .button-size {
  width: 24px;
  margin: 0 12px 0 0;
  height: 24px;
  background-color: #f2f2f2;
  border-radius: 2px;
}
#bdpListDetails .secondHeader {
  width: 30% !important;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #1d2125;
}
#bdpListDetails .padding-caption-top {
  margin-top: 20px;
}
#bdpListDetails .statusPill-completed {
  border-radius: 10px;
  font-weight: 500;
  background: #828282;
  border-style: solid;
  border-color: #828282;
  border-width: thin;
  color: #fff;
}
#bdpListDetails .statusPill-inTransit {
  border-radius: 10px;
  font-weight: 500;
  background: none;
  border-style: solid;
  border-color: #03a17b;
  border-width: thin;
  color: #03a17b;
}
#bdpListDetails .statusPill-notDeparted {
  border-radius: 10px;
  font-weight: 500;
  background: none;
  border-style: solid;
  border-color: #828282;
  border-width: thin;
  color: #828282;
}
#bdpListDetails table {
  width: 100%;
}
#bdpListDetails div > tr > th {
  width: 200px;
  text-align: left;
  font-size: 16px;
  padding-bottom: 8px;
}
#bdpListDetails div > tr > td {
  width: 200px;
  font-size: 14px;
  text-transform: revert;
  padding-bottom: 8px;
}
#bdpListDetails .caption > tr > th {
  width: 20px;
}
#bdpListDetails .badges > div,
#bdpListDetails .badges .not-departed {
  color: #fff;
  text-align: center;
  padding: 4px 10px;
}
#bdpListDetails .badges > div.bdp-on-time,
#bdpListDetails .badges .not-departed.bdp-on-time {
  background-color: var(--bdpOntime);
}
#bdpListDetails .badges > div.bdp-late-by,
#bdpListDetails .badges .not-departed.bdp-late-by {
  background-color: var(--bdpDelay);
}
#bdpListDetails .badges > div.bdp-early-riser,
#bdpListDetails .badges .not-departed.bdp-early-riser {
  background-color: var(--bdpEarly);
}
#bdpListDetails .badges > div.bdp-inactive,
#bdpListDetails .badges .not-departed.bdp-inactive {
  background-color: var(--bdpInactive);
}
#bdpListDetails .emptyMessageContainer {
  display: flex;
  height: 300px;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}
#bdpListDetails .etaLabels {
  width: -moz-fit-content;
  width: fit-content;
  cursor: pointer;
  padding-right: 10px;
}
#bdpListDetails .key-ref {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 630px;
}
#bdpListDetails ::ng-deep div .p-panel-header {
  margin-top: 1rem;
  border: none;
  background-color: #e2edf6;
}
#bdpListDetails ::ng-deep div .p-panel-header .p-panel-header-icon:focus {
  box-shadow: none;
  background: none;
}
#bdpListDetails ::ng-deep div .p-panel-content {
  border: none;
}
#bdpListDetails .truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 600px;
  display: inline-block;
  vertical-align: top;
}
#bdpListDetails .truncate:hover::after {
  content: attr(data-fulltext);
  position: absolute;
  white-space: normal;
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 5px;
  z-index: 1000;
  max-width: 600px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: block;
  word-break: break-word;
}

@media screen and (max-width: 768px) {
  #bdpListDetails #logisticMilestoneColumn .forteen {
    width: 80px;
  }
  #bdpListDetails #logisticMilestoneColumn .seventeen {
    width: 120px;
  }
  #bdpListDetails #logisticMilestoneColumn .fifteen {
    width: 100px;
  }
  #bdpListDetails #logisticMilestoneColumn .ninteen {
    width: 140px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/direct-link/direct-link-list-details/direct-link-list-details.component.scss"],"names":[],"mappings":"AAUI;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AATR;AAWI;EACI,yBAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;AATR;AAYQ;EACI,UAAA;AAVZ;AAYQ;EACI,UAAA;AAVZ;AAYQ;EACI,UAAA;AAVZ;AAYQ;EACI,UAAA;AAVZ;AAeI;EACI,kBAAA;EACA,iBAAA;EAEA,0BAAA;AAdR;AAkBQ;EACI,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAhBZ;AAmBQ;EACI,sBAAA;AAjBZ;AAoBQ;EACI,WAAA;AAlBZ;AAqBQ;EACI,mBAAA;AAnBZ;AAqBC;EACW,qBAAA;EACA,gBAAA;AAnBZ;AAsBQ;EACI,6BAAA;EACA,6BAAA;EACA,oCAAA;EACA,oCAAA;EACA,4CAAA;EACA,0CAAA;EACA,kDAAA;EACA,iCAAA;EACA,2CAAA;EACA,2CAAA;EACA,mDAAA;EACA,qCAAA;AApBZ;AAuBQ;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AArBZ;AAwBQ;EACI,+BAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,+BAAA;AAtBZ;AAyBQ;EACI,0BAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,+BAAA;AAvBZ;AA0BQ;EACI,4BAAA;AAxBZ;AA2BQ;EACI,6BAAA;AAzBZ;AA4BQ;EACI,yBAAA;AA1BZ;AA6BQ;EACI,qBAAA;EACA,gBAAA;AA3BZ;AA6BQ;EAEI,qBAAA;EACA,gBAAA;AA5BZ;AAgCoB;EACI,4BAAA;EACA,UAAA;EACA,yBAAA;AA9BxB;AAiCoB;EACI,0BAAA;EACA,gCAAA;AA/BxB;AAoCY;EACI,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AAlChB;AAoCgB;EACI,uBAAA;EACA,qBAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,iBAAA;EACA,gBAAA;AAlCpB;AAqCgB;EACI,YAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,4BAAA;AAnCpB;AAwCQ;EACI,oBAAA;EACC,qBAAA;EACD,gBAAA;AAtCZ;AAuCY;EACI,mBAAA;AArChB;AA0CoB;EACI,4BAAA;EACA,UAAA;EAEA,uBAAA;EACA,qBAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,+BAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,wCAAA;AAzCxB;AA4DY;EACI,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AA1DhB;AA4DgB;EACI,uBAAA;EACA,qBAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,+BAAA;EACA,iBAAA;EACA,gBAAA;EACA,oCAAA;EACA,YAAA;AA1DpB;AA2EQ;EACI,oBAAA;AAzEZ;AA4EQ;EACI,mBAAA;AA1EZ;AA6EY;EACI,yBAAA;EACA,yBAAA;AA3EhB;AA8EY;EACI,YAAA;AA5EhB;AA+EY;EACI,YAAA;AA7EhB;AAoFI;EACI,yBAAA;EACA,kBAAA;AAlFR;AAqFI;EAEI,kBAAA;AApFR;AAyFQ;EACI,aAAA;AAvFZ;AA2FI;EACI,mBAAA;AAzFR;AA4FI;EACI,mBAAA;EACA,6BAAA;AA1FR;AA6FI;EACI,gBAAA;AA3FR;AA8FI;EACI,gBAAA;AA5FR;AA+FI;EACI,oCAAA;AA7FR;AAgGI;EACI,4BAAA;EACA,uBAAA;EACA,iBAAA;AA9FR;AAkGI;EACI,eAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EAEA,iBAAA;AAjGR;AAqGQ;EACI,qBAAA;AAnGZ;AA8GQ;EACI,eAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EAEA,iBAAA;AA7GZ;AAiHI;EACI,4BAAA;EACA,qBAAA;EACA,yBAAA;AA/GR;AAkHI;EACI,2BAAA;EACA,uBAAA;EACA,qBAAA;AAhHR;AAmHI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AAjHR;AAoHI;EACI,yBAAA;AAlHR;AAqHI;EACI,4BAAA;AAnHR;AAuHQ;EACI,kBAAA;EACA,QAAA;EACA,UAAA;AArHZ;AAyHI;EACI,6BAAA;EACA,6BAAA;AAvHR;AA0HI;EACI,4BAAA;EACA,qBAAA;EACA,6BAAA;AAxHR;AA6HQ;EAEI,8BAAA;EACA,aAAA;EACA,mBAAA;AA5HZ;AA+HgB;EACI,YAAA;AA7HpB;AAkIgB;EACI,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;AAhIpB;AAkIoB;EACI,gBAAA;AAhIxB;AAsIQ;EACI,kBAAA;AApIZ;AAsIY;EACI,YAAA;AApIhB;AAuIY;EACI,mBAAA;EACA,iBAAA;AArIhB;AAwIY;EACI,WAAA;EACA,WAAA;EACA,gBAAA;EACA,4BAAA;EACA,kBAAA;EACA,kBAAA;EACA,iCAAA;EACA,eAAA;AAtIhB;AAwIgB;EACI,8BAAA;AAtIpB;AAyIgB;EAEI,8BAAA;AAxIpB;AAgJwB;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;AA9I5B;AAiJgC;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AA/IpC;AAoJwB;EACI,eAAA;AAlJ5B;AAsJoB;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AApJxB;AAsJwB;EACI,yBAAA;EACA,WAAA;AApJ5B;AAyJwB;EACI,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;AAvJ5B;AA2JwB;;EAEI,eAAA;AAzJ5B;AA4JwB;EACI,iBAAA;EACA,kBAAA;AA1J5B;AA4J4B;EACI,oBAAA;EACA,WAAA;EACA,yBAAA;AA1JhC;AA6J4B;EACI,yBAAA;EACA,WAAA;AA3JhC;AA6KQ;EACI,gBAAA;AA3KZ;AAgLQ;EACI,gBAAA;AA9KZ;AAmLQ;EACI,gBAAA;AAjLZ;AAqLI;EACI,YAAA;EACA,aAAA;AAnLR;AAsLI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AApLR;AAuLI;EACI,gBAAA;EACA,WAAA;AArLR;AAwLI;EACI,eAAA;EACA,cAAA;EACA,iBAAA;AAtLR;AAyLI;EACI,+BAAA;EACA,mBAAA;AAvLR;AA0LI;EACI,cAAA;AAxLR;AA2LI;EACI,eAAA;AAzLR;AA4LI;EACI,eAAA;EACA,yBAAA;EACA,iBAAA;AA1LR;AA6LI;EACI,mBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;AA3LR;AA8LI;EACI,mBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;AA5LR;AA+LI;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AA7LR;AAgMI;EACI,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA9LR;AAiMI;EACI,gBAAA;AA/LR;AAkMI;EACI,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;AAhMR;AAkMI;EACI,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;AAhMR;AAkMI;EACI,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;AAhMR;AAmMI;EACI,WAAA;AAjMR;AAoMI;EACI,YAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAlMR;AAqMI;EACI,YAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;AAnMR;AAsMI;EACI,WAAA;AApMR;AAwMQ;;EAEI,WAAA;EACA,kBAAA;EACA,iBAAA;AAtMZ;AAwMY;;EACI,kCAAA;AArMhB;AAwMY;;EACI,iCAAA;AArMhB;AAwMY;;EACI,iCAAA;AArMhB;AAwMY;;EACI,oCAAA;AArMhB;AAyMI;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAvMR;AAyMI;EACI,uBAAA;EAAA,kBAAA;EACA,eAAA;EACA,mBAAA;AAvMR;AAyMI;EACI,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAvMR;AAgNQ;EACI,gBAAA;EAOA,YAAA;EACA,yBAAA;AApNZ;AA8MY;EACI,gBAAA;EACA,gBAAA;AA5MhB;AAmNQ;EACI,YAAA;AAjNZ;AAqNI;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;AAnNR;AAsNM;EACE,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,wCAAA;EACA,cAAA;EACA,sBAAA;AApNR;;AAwNA;EAGY;IACI,WAAA;EAvNd;EAyNU;IACI,YAAA;EAvNd;EAyNU;IACI,YAAA;EAvNd;EAyNU;IACI,YAAA;EAvNd;AACF","sourcesContent":["#bdpListDetails {\n    //ng deep for prime ng components cs to override\n    // ::ng-deep {\n    //     .p-tabview .p-tabview-nav {\n    //         background: #e2edf6;\n    // }\n    //For making the tabs scrollable.\n\n    // For US 4738 CSS\n\n    .get-direct-link{\n        position: absolute;\n        z-index: 9;\n        right: 4%;\n        margin-top: 10px;\n    }\n    .bdp-record-overload {\n        background-color: #ffcece;\n        color: #1d2125;\n        padding: 20px 20px 20px 20px;\n        border-radius: 6px;\n    }\n    #logisticMilestoneColumn {\n        .forteen {\n            width: 14%;\n        }\n        .seventeen {\n            width: 17%;\n        }\n        .fifteen {\n            width: 15%;\n        }\n        .ninteen {\n            width: 19%;\n        }\n    }\n\n    // For US 5162\n    #viewDocs {\n        margin-right: 12px;\n        background: white;\n        // color: #2d74ff;\n        text-decoration: underline;\n    }\n\n    ::ng-deep {\n        .p-tabview .p-tabview-nav {\n            background: #e2edf6;\n            flex-wrap: nowrap;\n            overflow-x: auto;\n            overflow-y: hidden;\n        }\n\n        .p-dropdown .p-dropdown-panel {\n            top: -106px !important;\n        }\n\n        .p-tabview .p-tabview-nav::-webkit-scrollbar {\n            height: 2px;\n        }\n\n        .p-tabview .p-tabview-nav::-webkit-scrollbar-track {\n            border-radius: 10px;\n        }\n .bdp-milestone-switcher {\n            display: inline-block;\n            margin-top: 10px;\n        }\n\n        .p-toggleswitch.bdp-milestone-switcher {\n            --p-toggleswitch-width: 420px;\n            --p-toggleswitch-height: 30px;\n            --p-toggleswitch-border-radius: 16px;\n            --p-toggleswitch-background: #2d74ff;\n            --p-toggleswitch-checked-background: #2d74ff;\n            --p-toggleswitch-hover-background: #2d74ff;\n            --p-toggleswitch-checked-hover-background: #2d74ff;\n            --p-toggleswitch-handle-size: 50%;\n            --p-toggleswitch-handle-border-radius: 16px;\n            --p-toggleswitch-handle-background: #ffffff;\n            --p-toggleswitch-handle-checked-background: #ffffff;\n            --p-toggleswitch-slide-duration: 0.4s;\n        }\n\n        .p-toggleswitch.bdp-milestone-switcher .p-toggleswitch-slider {\n            width: 420px;\n            height: 30px;\n            background-color: #2d74ff;\n            position: relative;\n            border-radius: 16px;\n            margin-top: 10px;\n            margin-bottom: 8px;\n        }\n\n        .p-toggleswitch.bdp-milestone-switcher .p-toggleswitch-slider::before {\n            content: \"Logistics Milestones\";\n            height: 26px;\n            width: 50%;\n            position: absolute;\n            left: 3px;\n            top: 2px;\n            text-align: center;\n            border-radius: 16px;\n            background-color: #ffffff;\n            line-height: 24px;\n            font-weight: 600;\n            transition: transform 0.4s ease;\n        }\n\n        .p-toggleswitch.bdp-milestone-switcher .p-toggleswitch-slider::after {\n            content: \"File Milestones\";\n            height: 26px;\n            width: 50%;\n            position: absolute;\n            right: 3px;\n            top: 2px;\n            text-align: center;\n            color: #ffffff;\n            line-height: 24px;\n            font-weight: 600;\n            transition: transform 0.4s ease;\n        }\n\n        .p-toggleswitch.bdp-milestone-switcher.p-toggleswitch-checked .p-toggleswitch-slider::before {\n            transform: translateX(204px);\n        }\n\n        .p-toggleswitch.bdp-milestone-switcher.p-toggleswitch-checked .p-toggleswitch-slider::after {\n            transform: translateX(-204px);\n        }\n\n        .p-toggleswitch {\n            color: #a9a9a9 !important;\n        }\n\n        .bdp-route-switcher {\n            display: inline-block;\n            margin-top: 10px;\n        }\n        .bdp-app-switcher {\n\n            display: inline-block;\n            margin-top: 10px;\n\n            &.p-inputswitch-checked {\n                .p-inputswitch-slider {\n                    &::before {\n                        transform: translateX(196px);\n                        left: 10px;\n                        content: 'View Documents';\n                    }\n\n                    &::after {\n                        transform: translateX(0px);\n                        content: 'Document Distribution';\n                    }\n                }\n            }\n\n            .p-inputswitch-slider {\n                background-color: #2D74FF;\n                display: block;\n                margin-top: 10px;\n                margin-bottom: 8px;\n                width: 420px;\n                height: 30px;\n\n                &::before {\n                    height: 26px !important;\n                    width: 50% !important;\n                    left: 3px;\n                    top: 11px;\n                    text-align: center;\n                    border-radius: 16px;\n                    content: \"Document Distribution\";\n                    line-height: 24px;\n                    font-weight: 600;\n                }\n\n                &::after {\n                    height: 28px;\n                    width: 50%;\n                    color: #fff;\n                    position: absolute;\n                    text-align: center;\n                    content: 'View Documents';\n                    line-height: 28px;\n                    transform: translateX(196px);\n                }\n            }\n        }\n\n        .bdp-milestone-switcher {\n            pointer-events: none; // Prevents any mouse interaction\n             display: inline-block;\n            margin-top: 10px;\n            .p-inputswitch {\n                cursor: not-allowed;\n              }\n\n            &.p-inputswitch-checked {\n                .p-inputswitch-slider {\n                    &::before {\n                        transform: translateX(196px);\n                        left: 10px;\n                        // content: 'File Milestones';\n                        height: 26px !important;\n                        width: 50% !important;\n                        left: 3px;\n                        top: 11px;\n                        text-align: center;\n                        border-radius: 16px;\n                        content: 'Logistics Milestones';\n                        line-height: 24px;\n                        font-weight: 600;\n                        background-color: #2D74FF;\n                        color: white;\n                        position: absolute;\n                        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n                          \n                    } \n\n                    // &::after {\n                    //     transform: translateX(0px);\n                        \n                    //     content: 'Logistics Milestones';\n                    //     background-color: #2D74FF;  // Blue background for Logistics Milestones\n                    //     color: white;               // White text for contrast\n                    //     padding: 2px 10px;         // Add some padding\n                    //     border-radius: 4px;        // Optional: rounded corners\n                    //     position: absolute;        // Ensure proper positioning\n                    //     white-space: nowrap;  \n                        \n                    // }\n                }\n            }\n\n            .p-inputswitch-slider {\n                background-color: white;\n                display: block;\n                margin-top: 10px;\n                margin-bottom: 8px;\n                width: 420px;\n                height: 30px;\n\n                &::before {\n                    height: 26px !important;\n                    width: 50% !important;\n                    left: 3px;\n                    top: 11px;\n                    text-align: center;\n                    border-radius: 16px;\n                    content: 'Logistics Milestones';\n                    line-height: 24px;\n                    font-weight: 600;\n                    background-color: #2D74FF!important;\n                    color: white;\n\n                }\n\n                // &::after {\n                //     height: 28px;\n                //     width: 50%;\n                //     color: #fff;\n                //     position: absolute;\n                //     text-align: center;\n                //     content: \" File Milestones\";\n                //     line-height: 28px;\n                //     transform: translateX(196px);\n                // }\n            }\n        }\n\n        .bdp-milestone-switcher-wrapper {\n            padding-bottom: 40px;\n        }\n\n        .p-tabview .p-tabview-nav::-webkit-scrollbar-thumb {\n            border-radius: 10px;\n        }\n        #linkOverlay {\n            button.p-button {\n                background-color: #ff2ded;\n                color: rgb(255, 255, 255);\n            }\n\n            .p-overlaypanel-content {\n                width: 550px;\n            }\n\n            input {\n                width: 405px;\n            }\n        }\n    }\n\n\n\n    .legs-background {\n        color: #2d74ff !important;\n        border-radius: 3px;\n    }\n\n    .legs-geoFenceFlag-background {\n        // color: #e2edf6 !important;\n        border-radius: 3px;\n    }\n\n    //For Documents Table size\n    #docTable {\n        ::ng-deep .p-datatable table {\n            display: grid\n        }\n    }\n\n    ::ng-deep .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {\n        background: #e2edf6;\n    }\n\n    ::ng-deep .p-tabview .p-tabview-nav li .p-tabview-nav-link {\n        background: #e2edf6;\n        padding: 16px 24px !important;\n    }\n\n    :ng-deep .p-tabview .p-tabview-nav li .p-tabview-nav-link:focus {\n        box-shadow: none;\n    }\n\n    :ng-deep .p-tabview .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus {\n        box-shadow: none;\n    }\n\n    ::ng-deep .p-tabview .p-tabview-panels {\n        padding: 2px 8px 0px 16px !important;\n    }\n\n    ::ng-deep .p-datatable .p-datatable-thead > tr > th {\n        background: white !important;\n        border: none !important;\n        padding-top: 20px;\n        // padding-left: 0;\n    }\n\n    ::ng-deep .p-datatable .p-datatable-tbody > tr > td {\n        padding-left: 5;\n        border: none;\n        font-size: 14px;\n        font-weight: 400;\n        // color: #1d2125;\n        line-height: 20px;\n    }\n\n    #docTable {\n        ::ng-deep .p-datatable .p-datatable-tbody>tr>td {\n            width: 30% !important;\n            //     padding-left: 5;\n            //     border: none;\n            //     font-size: 14px;\n            //     font-weight: 400;\n            //    // color: #1d2125;\n            //     line-height: 20px;\n        }\n    }\n\n    #legs {\n        ::ng-deep .p-datatable .p-datatable-tbody>tr>td {\n            padding-left: 5;\n            border: none;\n            font-size: 14px;\n            font-weight: 400;\n            //color: #1d2125;\n            line-height: 20px;\n        }\n    }\n\n    ::ng-deep .p-tabview .p-tabview-panels {\n        max-height: 602px !important;\n        padding: 0 !important;\n        overflow: auto !important;\n    }\n\n    ::ng-deep .p-datatable .p-datatable-header {\n        background: none !important;\n        border: none !important;\n        padding: 0 !important;\n    }\n\n    ::ng-deep .p-tabview-nav-link {\n        color: #1d2125;\n        font-size: 16px;\n        font-weight: 500;\n        line-height: 24px;\n        height: 56px;\n    }\n\n    ::ng-deep .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {\n        color: #2d74ff !important;\n    }\n\n    ::ng-deep .p-datatable .p-datatable-scrollable-header {\n        background: white !important;\n    }\n\n    ::ng-deep .p-badge {\n        &.bdp-alert-badge {\n            position: absolute;\n            top: 4px;\n            right: 8px;\n        }\n    }\n\n    ::ng-deep .docsTable {\n        overflow-y: hidden !important;\n        max-height: 35.6em !important;\n    }\n\n    ::ng-deep .docPanel {\n        max-height: 600px !important;\n        padding: 0 !important;\n        overflow-y: hidden !important;\n    }\n\n    //prime ng component styling ends here\n    ::ng-deep {\n        .bdp-align-ctrl {\n            // width: 250px;\n            justify-content: space-between;\n            display: flex;\n            flex-direction: row;\n\n            .p-dataview-layout-options {\n                button {\n                    height: 32px;\n                }\n            }\n\n            #badgeButton {\n                .p-button {\n                    padding: 4px;\n                    background-color: #2f80ed;\n                    line-height: 1px;\n                    color: white;\n\n                    .p-badge {\n                        margin: 0px 10px;\n                    }\n                }\n            }\n        }\n\n        .bdp-alert-list {\n            position: relative;\n\n            .bdp-alert-list-item {\n                margin: 10px;\n            }\n\n            .readBackground {\n                background: #edfaff;\n                font-weight: bold;\n            }\n\n            .bdp-alert {\n                float: left;\n                width: 100%;\n                margin: 15px 0px;\n                /* border: 1px solid #ccc; */\n                border-radius: 6px;\n                padding: 10px 20px;\n                box-shadow: 0px 1px 5px -1px #444;\n                cursor: pointer;\n\n                &.bdp-vesselDelay {\n                    border-left: 6px solid #1da9e1;\n                }\n\n                &.bdp-bookings,\n                &.bdp-omission {\n                    border-left: 6px solid #e3e3e4;\n                }\n\n                .notif-heading {\n                    .bdp-heading {\n                        // float: left;\n                        // width: 100%;\n\n                        span {\n                            min-width: 30px;\n                            height: 30px;\n                            float: left;\n                            text-align: center;\n                            margin-right: 10px;\n                            align-items: center;\n                            display: flex;\n\n                            i {\n                                &.bdp-icon {\n                                    color: #fff;\n                                    width: 100%;\n                                    height: 100%;\n                                    background: #1b74c5;\n                                    border-radius: 15px;\n                                    line-height: 31px;\n                                }\n                            }\n                        }\n\n                        &.bdp-alert-label {\n                            font-size: 16px;\n                        }\n                    }\n\n                    .bdp-menu-icon {\n                        width: 24px;\n                        text-align: center;\n                        float: right;\n                        height: 24px;\n                        border-radius: 3px;\n                        padding: 5px;\n\n                        &:hover {\n                            background-color: #2d74ff;\n                            color: #fff;\n                        }\n                    }\n\n                    ::ng-deep {\n                        .p-overlaypanel {\n                            margin-top: 10px;\n                            position: absolute;\n                            top: 60px !important;\n                            right: 40px !important;\n                            left: auto !important;\n                            // width: 210px;\n                        }\n\n                        .p-overlaypanel:after,\n                        .p-overlaypanel:before {\n                            content: normal;\n                        }\n\n                        p {\n                            padding: 5px 10px;\n                            border-radius: 6px;\n\n                            &.bdp-disabled {\n                                pointer-events: none;\n                                color: #fff;\n                                background-color: #d6d6d6;\n                            }\n\n                            &:hover {\n                                background-color: #2f80ed;\n                                color: #fff;\n                            }\n                        }\n                    }\n                }\n\n                .bdp-alert-body {\n                    // float: left;\n                }\n\n                .bdp-time {\n                    // float: left;\n                }\n            }\n        }\n    }\n\n    #eventName {\n        .list-item-text-ellipses {\n            max-width: 140px;\n        }\n    }\n\n    #vessel {\n        .list-item-text-ellipses {\n            max-width: 110px;\n        }\n    }\n\n    #eventLocation {\n        .list-item-text-ellipses {\n            max-width: 120px;\n        }\n    }\n\n    #hideEventCodeToggle {\n        float: right;\n        display: flex;\n    }\n\n    .shipment-information-header-font {\n        font-size: 16px;\n        font-weight: 600;\n        line-height: 20px;\n        color: #1d2125;\n        white-space: nowrap;\n        background: #ccc;\n        float: left;\n        padding: 5px 5px;\n        border-radius: 3px;\n    }\n\n    .box-icon-header {\n        text-align: left;\n        width: 2rem;\n    }\n\n    .box-icon {\n        font-size: 16px;\n        color: #e8f1f8;\n        margin-right: 8px;\n    }\n\n    .p-tag {\n        border-radius: 10rem !important;\n        background: #1d2125;\n    }\n\n    .color {\n        color: #2d74ff;\n    }\n\n    .check-icon {\n        font-size: 12px;\n    }\n\n    .list-details-header {\n        font-size: 20px;\n        color: #1d2125 !important;\n        line-height: 24px;\n    }\n\n    .back-button {\n        background: #e8f1f8;\n        border: none;\n        outline: none;\n        color: #323232;\n    }\n\n    .angle-left-right {\n        background: #e8f1f8;\n        border: none;\n        outline: none;\n        font-size: 16px;\n        color: #323232;\n    }\n\n    .button-size {\n        width: 24px;\n        margin: 0 12px 0 0;\n        height: 24px;\n        background-color: #f2f2f2;\n        border-radius: 2px;\n    }\n\n    .secondHeader {\n        width: 30% !important;\n        font-weight: 600;\n        font-size: 14px;\n        line-height: 20px;\n        color: #1d2125;\n    }\n\n    .padding-caption-top {\n        margin-top: 20px;\n    }\n\n    .statusPill-completed {\n        border-radius: 10px;\n        font-weight: 500;\n        background: #828282;\n        border-style: solid;\n        border-color: #828282;\n        border-width: thin;\n        color: #fff;\n    }\n    .statusPill-inTransit {\n        border-radius: 10px;\n        font-weight: 500;\n        background: none;\n        border-style: solid;\n        border-color: #03a17b;\n        border-width: thin;\n        color: #03a17b;\n    }\n    .statusPill-notDeparted {\n        border-radius: 10px;\n        font-weight: 500;\n        background: none;\n        border-style: solid;\n        border-color: #828282;\n        border-width: thin;\n        color: #828282;\n    }\n\n    table {\n        width: 100%;\n    }\n\n    div > tr > th {\n        width: 200px;\n        text-align: left;\n        font-size: 16px;\n        padding-bottom: 8px;\n    }\n\n    div > tr > td {\n        width: 200px;\n        font-size: 14px;\n        text-transform: revert;\n        padding-bottom: 8px;\n    }\n\n    .caption > tr > th {\n        width: 20px;\n    }\n\n    .badges {\n        & > div,\n        .not-departed {\n            color: #fff;\n            text-align: center;\n            padding: 4px 10px;\n\n            &.bdp-on-time {\n                background-color: var(--bdpOntime);\n            }\n\n            &.bdp-late-by {\n                background-color: var(--bdpDelay);\n            }\n\n            &.bdp-early-riser {\n                background-color: var(--bdpEarly);\n            }\n\n            &.bdp-inactive{\n                background-color: var(--bdpInactive);\n            }\n        }\n    }\n    .emptyMessageContainer {\n        display: flex;\n        height: 300px;\n        align-items: center;\n        justify-content: center;\n        font-size: 24px;\n    }\n    .etaLabels {\n        width: fit-content;\n        cursor: pointer;\n        padding-right: 10px;\n    }\n    .key-ref {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        max-width: 630px;\n    }\n\n    // .table-row>td,\n    // th {\n    //     width: 20%;\n    // }\n\n    ::ng-deep {\n        div .p-panel-header {\n            margin-top: 1rem;\n\n            .p-panel-header-icon:focus {\n                box-shadow: none;\n                background: none;\n            }\n\n            border: none;\n            background-color: #e2edf6;\n        }\n\n        div .p-panel-content {\n            border: none;\n        }\n    }\n\n    .truncate {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        max-width: 600px;\n        display: inline-block;\n        vertical-align: top;\n      }\n      \n      .truncate:hover::after {\n        content: attr(data-fulltext);\n        position: absolute;\n        white-space: normal;\n        background-color: #fff;\n        border: 1px solid #ccc;\n        padding: 5px;\n        z-index: 1000;\n        max-width: 600px;\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n        display: block;\n        word-break: break-word;\n      }\n      \n}\n@media screen and (max-width: 768px) {\n    #bdpListDetails {\n        #logisticMilestoneColumn {\n            .forteen {\n                width: 80px;\n            }\n            .seventeen {\n                width: 120px;\n            }\n            .fifteen {\n                width: 100px;\n            }\n            .ninteen {\n                width: 140px;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
